// extracted by mini-css-extract-plugin
export default {"flexCenter":"NameCardCell_flexCenter__2+m-D","img":"NameCardCell_img__FuTir","text":"NameCardCell_text__O3Kya","clickable":"NameCardCell_clickable__OTzCA"};